import { BaseService } from './baseService';
import { ImplantDto, ImplantFormData } from '../types/implant';

class ImplantService extends BaseService<ImplantDto, ImplantFormData> {
    constructor() {
        super('/Implant');
    }
}

export const implantService = new ImplantService();